'use client';

import H1 from '@/components/typography/h1';
import ArticleItem from '@/components/ui/article-item';
import { Artikelen } from '@/payload-types';
import { useTranslation } from 'react-i18next';

interface ArticleListProps {
    articles: Artikelen[];
}

export default function ArticleList({ articles }: ArticleListProps) {
    const { t } = useTranslation();

    return (
        <div>
            <div className="flex flex-col border-b border-black">
                <div className="mt-[7rem] mb-[1.5rem] p-4 lg:mx-auto lg:mt-[8rem]">
                    <H1 className="inline">{t('hero')}</H1>
                </div>
                <div className="mb-20 flex flex-col lg:mt-8">
                    {articles.map((item, index) => (
                        <ArticleItem
                            key={index}
                            title={item.titel}
                            date={item.updatedAt as string}
                            slug={item.slug}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
